import { getCurrentEmployee, getDefaultRFQID } from '@/utils/shared'

export class ModelRFQ2s {
  constructor () {
    this.id = null
    this.rfqid = getDefaultRFQID()
    this.supplierCompanyID = null
    this.supplierContactID = null
    this.employeeID = getCurrentEmployee().id
    this.entryDate = new Date()
    this.partID = null
    this.conditionID = null
    this.qty = 1
    this.price = ''
    this.currencyID = null
    this.partSN = ''
    this.paymentTermID = null
    this.priceMax = ''
    this.priceMin = ''
    this.releaseID = null
    this.delivery = ''
    this.traceabilityCompanyID = null
    this.estimatedDeliveryDate = null
    this.tagInfoCompanyID = null
    this.tagDate = null
    this.remarks = null
    this.typeOfOperationConditionID = null
    this.reasonForRemoval = null
    this.chosen = false
    this.warrantyRequested = false
    this.receivedDate = null
  }
}
